import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import ChevronIcon from '../assets/icons/chevron-small.svg'
import { AnchorLink } from './AnchorLink'
import { LinkProps } from './Link'

export interface LargeLinkProps extends Omit<LinkProps, 'className'> {
  additionalClassName?: string
  chevronOffset?: string
  disabled?: boolean
  fontClassName?: string
}

export const LargeLink = ({
  additionalClassName,
  chevronOffset,
  children,
  customAttributes,
  disabled,
  fontClassName = 'font-t-bold text-t-500',
  ...restOfProps
}: PropsWithChildren<LargeLinkProps>) => {
  const className = classNames(
    'relative inline-flex items-center pb-2 transition-hover',
    fontClassName,
    {
      'text-primary group hover:text-secondary focus:text-primary focus:outline-none':
        !disabled,
      'text-secondary-darker': disabled,
    },
    additionalClassName
  )

  const content = (
    <>
      <span className="inline-block">{children}</span>

      {/* Hide with opacity instead of conditional render to avoid affecting layout */}
      <ChevronIcon
        className={classNames(
          'inline-block w-10 h-10 ml-10 fill-current text-primary transition-hover transform rotate-180',
          'group-hover:text-secondary',
          chevronOffset,
          {
            'opacity-0': disabled,
          }
        )}
      />

      <span
        className={classNames(
          'absolute bottom-0 left-0 -right-1 min-w-full h-2 bg-transparent opacity-25 transition-hover',
          'group-focus:bg-primary',
          {
            'opacity-0': disabled,
          }
        )}
        aria-hidden="true"
      ></span>
    </>
  )

  return disabled ? (
    <span className={className} {...customAttributes}>
      {content}
    </span>
  ) : (
    <AnchorLink
      {...restOfProps}
      className={className}
      customAttributes={customAttributes}
    >
      {content}
    </AnchorLink>
  )
}
